/** Ключ в localStorage, который говорит о том, что вход был выполнен от лица sale manager */
export const IS_SALE_MANAGER = "isSaleManager";
